import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
export function When({
  can,
  cannot,
  policy,
  children
}) {
  if (can && !(policy !== null && policy !== void 0 && policy.can(can))) {
    return null;
  }
  if (cannot && policy !== null && policy !== void 0 && policy.can(cannot)) {
    return null;
  }
  return /*#__PURE__*/_jsx(_Fragment, {
    children: children
  });
}